import {
    Close,
    ForkRightOutlined,
    ListAltRounded,
    Work,
} from "@mui/icons-material";
import { Box, Drawer, IconButton, List, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { theme } from "../../theme";
import { Link, useLocation } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Icon } from "@iconify/react";
import { SubMenuCustom } from "./SubMenuCustom";
import { useSelector } from "react-redux";
import { canAccess } from "../../utils/utils";
import { getApi } from "../../config/configAxios";

const getWebsiteSetting = async () => {
    return getApi("/website-setting");
};
const SideBar = ({ setOpen, open }) => {
    const isMdScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));
    const permissions = useSelector((state) => state.auth.permissions || []);
    const [setting, setSetting] = useState(null);
    const location = useLocation();

    useEffect(() => {
        if (!isMdScreen) {
            setOpen(false);
        }
    }, [isMdScreen, setOpen]);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    useEffect(() => {
        const fetchWebsiteSetting = async () => {
            try {
                const res = await getWebsiteSetting();
                setSetting(res?.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchWebsiteSetting();
    }, []);
    console.log(setting);

    const collapsed = false;
    const breakPoint = true;
    return (
        <>
            <Box sx={{ display: "flex" }} position={"relative"}>
                {isMdScreen ||
                    (open && (
                        <IconButton
                            color="inherit"
                            aria-label="Open sidebar"
                            edge="start"
                            onClick={toggleDrawer}
                            sx={{
                                display: {
                                    xs: "block",
                                    md: "none",
                                    position: "absolute",
                                    top: "35px",
                                    left: "330px",
                                    zIndex: 9999,
                                },
                            }}
                        >
                            <Close />
                        </IconButton>
                    ))}
                <Drawer
                    sx={{
                        zIndex: 1000,
                        position: "absolute",
                        width: "270px",
                        flexShrink: 0,
                        "& .MuiDrawer-paper": {
                            width: "260px",
                            boxSizing: "border-box",
                            overflowY: "auto",
                            borderRight: "0px",
                            boxShadow: theme.palette.boxShadow,
                        },
                        "& .MuiDrawer-paper::-webkit-scrollbar": {
                            width: "3px", // Width of the scrollbar
                        },
                        "& .MuiDrawer-paper::-webkit-scrollbar-track": {
                            background: "#f1f1f1", // Track color
                        },
                        "& .MuiDrawer-paper::-webkit-scrollbar-thumb": {
                            background: "#888", // Thumb color
                        },
                        display: isMdScreen ? "block" : open ? "block" : "none", // Show on md and larger screens, hide on xs screens unless open
                    }}
                    variant="persistent"
                    anchor="left"
                    open={isMdScreen || open} // Open on md and larger screens and when the open state is true
                >
                    <Sidebar
                        width="100%"
                        collapsed={collapsed}
                        breakPoint={breakPoint}
                        className="min-h-screen "
                    >
                        <div className="border-b p-5">
                            <Link to="https://lzbabar.com/" target="_blank">
                                <img
                                    className="max-h-24 m-auto"
                                    src={
                                        setting?.admin_logo
                                            ? `${process.env.REACT_APP_API_FILE_URL}${setting?.admin_logo}`
                                            : "https://images.vexels.com/media/users/3/142789/isolated/preview/2bfb04ad814c4995f0c537c68db5cd0b-multicolor-swirls-circle-logo.png"
                                    }
                                    alt=""
                                />
                            </Link>
                        </div>
                        <Menu>
                            {canAccess(permissions, "dashboard.view") && (
                                <>
                                    <Link to="/">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            Dashboard
                                        </MenuItem>
                                    </Link>
                                    <div className="border-b"></div>
                                </>
                            )}

                            {canAccess(permissions, "biography.view") && (
                                <>
                                    <Link to="/biography">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/biography"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            Biography
                                        </MenuItem>
                                    </Link>
                                    <div className="border-b"></div>
                                </>
                            )}

                            {(canAccess(permissions, "biography.view") ||
                                canAccess(permissions, "life_struggle.view")) && (
                                <>
                                    <Link to="/life-struggle">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/life-struggle"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            History of Life and Struggle
                                        </MenuItem>
                                    </Link>
                                    <div className="border-b"></div>
                                </>
                            )}

                            {canAccess(permissions, "citizen_request.view") && (
                                <>
                                    <Link to="/citizen-request">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/citizen-request"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            Citizen Request{" "}
                                        </MenuItem>
                                    </Link>
                                    <div className="border-b"></div>
                                </>
                            )}

                            {canAccess(permissions, "union.view") && (
                                <>
                                    <Link to="/unions">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/unions"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            Unions/Pourashava
                                        </MenuItem>
                                    </Link>
                                    <div className="border-b"></div>
                                </>
                            )}

                            {canAccess(permissions, "user.view") && (
                                <>
                                    <Link to="/users">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/users"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            Users
                                        </MenuItem>
                                    </Link>
                                    <div className="border-b"></div>
                                </>
                            )}

                            {/* <div className="border-b"></div>
              <Link to="/appointment">
                <MenuItem
                  icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                  className={
                    location.pathname === "/appointment"
                      ? "font-semibold text-white bg-blue-500 hover:text-black"
                      : ""
                  }
                >
                  Appointment{" "}
                </MenuItem>
              </Link> */}

                            {canAccess(permissions, "contact.view") && (
                                <>
                                    <div className="border-b"></div>
                                    <Link to="/contact">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/contact"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            Contact{" "}
                                        </MenuItem>
                                    </Link>
                                </>
                            )}

                            {canAccess(permissions, "slider.view") && (
                                <>
                                    <div className="border-b"></div>
                                    <Link to="/slider">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/slider"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            {" "}
                                            Slider{" "}
                                        </MenuItem>
                                    </Link>
                                </>
                            )}

                            {(canAccess(permissions, "services_category.view") ||
                                canAccess(permissions, "services.view")) && (
                                    <>
                                        <div className="border-b"></div>
                                        <SubMenuCustom
                                            label="Services"
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            url={["/services-category", "/services"]}
                                        >
                                            {canAccess(permissions, "services_category.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/services-category">
                                                        <MenuItem
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                            className={
                                                                location.pathname === "/services-category"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                        >
                                                            {" "}
                                                            Category{" "}
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}

                                            {/* {canAccess(permissions, "services.view") && (
                      <>
                        <div className="border-b"></div>
                        <Link to="/services">
                          <MenuItem
                            className={
                              location.pathname === "/services"
                                ? "font-semibold text-white bg-blue-500 hover:text-black"
                                : ""
                            }
                            icon={
                              <Icon
                                icon="ph:dot-duotone"
                                className="text-3xl"
                              />
                            }
                          >
                            {" "}
                            Services{" "}
                          </MenuItem>
                        </Link>
                      </>
                    )} */}
                                        </SubMenuCustom>
                                    </>
                                )}

                            {(canAccess(permissions, "about_us_category.view") ||
                                canAccess(permissions, "about_us_content.view")) && (
                                    <>
                                        <div className="border-b"></div>
                                        <SubMenuCustom
                                            label="About us"
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            url={["/about-us-category", "/about-us-content"]}
                                        >
                                            {canAccess(permissions, "about_us_category.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/about-us-category">
                                                        <MenuItem
                                                            className={
                                                                location.pathname === "/about-us-category"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                        >
                                                            About us category
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}

                                            {canAccess(permissions, "about_us_content.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/about-us-content">
                                                        <MenuItem
                                                            className={
                                                                location.pathname === "/about-us-content"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                        >
                                                            About us content
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}
                                        </SubMenuCustom>
                                    </>
                                )}

                            {(canAccess(permissions, "resource_category.view") ||
                                canAccess(permissions, "resource_content.view")) && (
                                    <>
                                        <div className="border-b"></div>
                                        <SubMenuCustom
                                            label="Resource"
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            url={["/resource-category", "/resource-content"]}
                                        >
                                            {canAccess(permissions, "resource_category.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/resource-category">
                                                        <MenuItem
                                                            className={
                                                                location.pathname === "/resource-category"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                        >
                                                            Resource category
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}

                                            {canAccess(permissions, "resource_content.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/resource-content">
                                                        <MenuItem
                                                            className={
                                                                location.pathname === "/resource-content"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                        >
                                                            Resource content
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}
                                        </SubMenuCustom>
                                    </>
                                )}

                            {(canAccess(permissions, "print_media.view") ||
                                canAccess(permissions, "electronic_media.view") ||
                                canAccess(permissions, "electronic_media.view")) && (
                                    <>
                                        <div className="border-b"></div>

                                        <SubMenuCustom
                                            label="Media"
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            url={["/print-media", "/electronic-media", "/blog"]}
                                        >
                                            {canAccess(permissions, "print_media.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/print-media">
                                                        <MenuItem
                                                            className={
                                                                location.pathname === "/print-media"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                        >
                                                            Print Media
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}

                                            {canAccess(permissions, "electronic_media.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/electronic-media">
                                                        <MenuItem
                                                            className={
                                                                location.pathname === "/electronic-media"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                        >
                                                            Electronic Media
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}

                                            {canAccess(permissions, "electronic_media.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/blog">
                                                        <MenuItem
                                                            className={
                                                                location.pathname === "/blog"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                        >
                                                            Blog
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}
                                        </SubMenuCustom>
                                    </>
                                )}

                            {(canAccess(permissions, "photo_gallery.view") ||
                                canAccess(permissions, "video_gallery.view") ||
                                canAccess(permissions, "photo_gallery_category.view")) && (
                                    <>
                                        <div className="border-b"></div>
                                        <SubMenuCustom
                                            label="Gallery"
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            url={[
                                                "/photo-gallery",
                                                "/video-gallery",
                                                "/photo-gallery-category",
                                            ]}
                                        >
                                            {canAccess(permissions, "photo_gallery_category.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/photo-gallery-category">
                                                        <MenuItem
                                                            className={
                                                                location.pathname === "/photo-gallery-category"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                        >
                                                            Photo gallery category
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}

                                            {canAccess(permissions, "photo_gallery.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/photo-gallery">
                                                        <MenuItem
                                                            className={
                                                                location.pathname === "/photo-gallery"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                        >
                                                            Photo gallery
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}

                                            {canAccess(permissions, "video_gallery.view") && (
                                                <>
                                                    <div className="border-b"></div>
                                                    <Link to="/video-gallery">
                                                        <MenuItem
                                                            className={
                                                                location.pathname === "/video-gallery"
                                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                                    : ""
                                                            }
                                                            icon={
                                                                <Icon
                                                                    icon="ph:dot-duotone"
                                                                    className="text-3xl"
                                                                />
                                                            }
                                                        >
                                                            Video gallery
                                                        </MenuItem>
                                                    </Link>
                                                </>
                                            )}
                                        </SubMenuCustom>
                                    </>
                                )}

                            {canAccess(permissions, "website_setting.view") && (
                                <>
                                    <div className="border-b"></div>
                                    <Link to="/website-setting">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/website-setting"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            Website setting
                                        </MenuItem>
                                    </Link>
                                </>
                            )}

                            {canAccess(permissions, "footer_link.view") && (
                                <>
                                    <div className="border-b"></div>
                                    <Link to="/footer-link">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/footer-link"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            Footer link
                                        </MenuItem>
                                    </Link>
                                </>
                            )}

                            {canAccess(permissions, "about_me.view") && (
                                <>
                                    <div className="border-b"></div>
                                    <Link to="/about-me">
                                        <MenuItem
                                            icon={<ListAltRounded sx={{ fontSize: "20px" }} />}
                                            className={
                                                location.pathname === "/about-me"
                                                    ? "font-semibold text-white bg-blue-500 hover:text-black"
                                                    : ""
                                            }
                                        >
                                            About me
                                        </MenuItem>
                                    </Link>
                                </>
                            )}

                            <div className="mb-5"></div>
                        </Menu>
                    </Sidebar>
                </Drawer>
            </Box>
        </>
    );
};

export default SideBar;
